import {httpService} from "@/modules/common/services"
import _ from 'lodash'
import {settingsService} from "./settingsService";

const fieldTypes = {
  subject: {
    type: 'subject',
    icon: 'icon-Mail',
    icon_dark: 'icon-envelop-fill-16',
    can_be_set_required: true,
    can_be_hidden: true,
  },
  multiline: {
    type: 'multiline',
    icon: 'icon-Mail',
    icon_dark: 'icon-envelop-fill-16',
    can_be_set_required: true,
    can_be_hidden: true,
  },
  email: {
    type: 'email',
    label: 'settings.client_card.client_status',
    icon: 'icon-Mail',
    icon_dark: 'icon-envelop-fill-16'
  },
  policy: {
    type: 'policy',
    icon: 'icon-Temp_ID-Card',
    icon_dark: 'icon-Temp_Temp_ID-Card_solid',
    editable: true
  },
  singleline: {
    type: 'singleline',
    label: 'settings.client_card.client_fields_types.single_line_text',
    icon: 'icon-Temp_ID-Card',
    icon_dark: 'icon-Temp_Temp_ID-Card_solid',
    can_be_deleted: true,
    can_be_removed: true,
    custom: true
  },
  identifier: {
    type: 'identifier',
    label: 'settings.client_card.client_fields_types.unique_id',
    icon: 'icon-Temp_ID-Card',
    icon_dark: 'icon-Temp_Temp_ID-Card_solid',
    can_be_deleted: true,
    can_be_removed: true
  },
  firstname: {
    type: 'firstname',
    label: 'settings.client_card.client_fields_types.first_name',
    icon: 'icon-Temp_ID-Card',
    icon_dark: 'icon-Temp_Temp_ID-Card_solid',
  },
  dropdown: {
    type: 'dropdown',
    label: 'settings.client_card.client_fields_types.drop_down_list',
    icon: 'icon-Temp_dropdown',
    icon_dark: 'icon-Temp_dropdown_solid',
    can_be_deleted: true,
    can_be_removed: true,
    custom: true
  },
  datepicker: {
    type: 'datepicker',
    label: 'settings.client_card.client_fields_types.date',
    icon: 'icon-Temp_Calendar2',
    icon_dark: 'icon-Temp_Calendar-16_solid',
    can_be_deleted: true,
    can_be_removed: true,
    custom: true
  },
  phone: {
    type: 'phone',
    label: 'settings.client_card.client_fields_types.phone',
    icon: 'icon-Temp_Mobile',
    icon_dark: 'icon-Temp_mobile_solid',
    can_be_removed: true,
    custom: true
  },
  'secondary-phone': {
    type: 'secondary-phone',
    label: 'settings.client_card.client_fields_types.secondary_phone',
    icon: 'icon-Phone',
    icon_dark: 'icon-Temp_phone-fill-16_solid',
    can_be_deleted: true,
    can_be_removed: true
  },
  checkbox: {
    type: 'checkbox',
    label: 'settings.client_card.client_fields_types.checkbox',
    icon: 'icon-Temp_checkbox',
    icon_dark: 'icon-Temp_checkbox_solid',
    can_be_deleted: true,
    can_be_removed: true,
    custom: true
  },
  'opt-in': {
    type: 'opt-in',
    label: 'settings.client_card.client_fields_types.opt_in_for_campaigns',
    icon: 'icon-Temp_opt-in',
    icon_dark: 'icon-Temp_opt-in_solid',
    can_be_deleted: true,
    can_be_removed: true
  },
  lastname: {
    type: 'lastname',
    label: 'settings.client_card.client_fields_types.last_name',
    icon: 'icon-Temp_ID-Card',
    icon_dark: 'icon-Temp_Temp_ID-Card_solid',
    can_be_deleted: false,
    can_be_removed: true
  },
  address: {
    type: 'address',
    label: 'settings.client_card.client_fields_types.address',
    icon: 'icon-Temp_Map-Marker2',
    icon_dark: 'icon-Temp_address_solid',
    can_be_deleted: false,
    can_be_removed: true
  },
  name: {
    type: 'name',
    label: 'settings.client_card.client_fields_types.name',
    icon: 'icon-Temp_ID-Card',
    icon_dark: 'icon-Temp_Temp_ID-Card_solid',
    can_be_deleted: false,
    can_be_removed: true,
    custom: true
  }
};

const clientFieldTypes = _.pick(fieldTypes, ['subject', 'multiline', 'email', 'policy', 'singleline', 'identifier', 'firstname', 'dropdown', 'datepicker', 'phone', 'secondary-phone', 'checkbox', 'opt-in', 'lastname', 'address']);
const matterFieldTypes = _.pick(fieldTypes, ['name', 'address', 'datepicker', 'singleline', 'dropdown', 'checkbox', 'identifier']);

async function getFields() {
  let res = await httpService.get('platform/v1/fields');
  let fields = res.data;

  for (let field of fields) {
    Object.assign(field, _.pick(fieldTypes[field['type']], ['icon', 'icon_dark', 'can_be_set_required', 'can_be_hidden', 'can_be_deleted', 'can_be_removed', 'custom']));
  }

  return Promise.resolve(fields);
}

async function getForms() {
  let temp = await httpService.get('platform/v1/forms');
  let forms = temp.data;

  for (let form of forms) {
    for (let section of form.sections) {
      for (let field of section.fields) {
        Object.assign(field, _.pick(fieldTypes[field['type']], ['icon', 'icon_dark', 'can_be_set_required', 'can_be_hidden', 'can_be_deleted', 'can_be_removed']));
      }
    }
  }

  return Promise.resolve(forms);
}

const getField = async (fieldId) => {
  try {
    let result = await httpService.get(`platform/v1/fields/${fieldId}`)
    let settings = await settingsService.get()
    result.data.enforce_opt_in = settings.should_enforce_opt_in
    if(result.data && result.status === "OK") {
      return result
    }
  } catch (e) {
    return e.response.data
  }
};

const getClientFieldType = (field) => {
  return clientFieldTypes[field.type];
};

const addField = async (field) => {

  try {
    let result = await httpService.post('platform/v1/fields',field)
    if(result.data && result.status === "OK") {
      return result
    }
  } catch (e) {
    return e.response.data
  }
};

const editField = async (field) => {
  try {
    let result = await httpService.put('platform/v1/fields/' + field.id,field)
    if(result.data && result.status === "OK") {
      return result
    }
  } catch (e) {
    return e.response.data
  }
};

const updateFieldInForm = async (field) => {
  try {
    let data = {
      required: field.required,
      hidden: field.hidden
    }
    let result = await httpService.put(`platform/v1/forms/${field.form}/fields/${field.id}`, data)
    if(result.data && result.status === "OK") {
      return result
    }
  } catch (e) {
    return e.response.data
  }
};

const deleteField = async (field) => {
  let result = await httpService.remove(`platform/v1/fields/${field.id}`)
  return result
};

const reOrderFields = async (fields) => {
  let data = {
    sections:[
      {
        editable: true,
        fields: fields
      }
    ],
    type: "client_card"
  }

  return httpService.put('platform/v1/forms',data)
};

const updateIntakeForm = (form) => {
  return httpService.put('platform/v1/forms',form)
};

const getClientStatuses = () => {
  return httpService.get('settings/client_status')
};

const updateClientStatus = async (id, label) => {
  const res = await httpService.put(`settings/client_status/${id}`, {new_label: label})
  if (res.status == "ERROR") throw new Error(res.message)

  return res.data
};

const addCustomStatus = async (label) => {
  const res = await httpService.post(`settings/client_status`, {label})
  if (res.status == "ERROR") throw new Error(res.message)

  return res.data
};

const removeCustomStatus = async (id) => {
  const res = await httpService.remove(`settings/client_status/${id}`)
  if (res.status == "ERROR") throw new Error(res.message)

  return res.data
};

export const clientFieldsService = {
  getFields,
  getForms,
  getField,
  clientFieldTypes,
  matterFieldTypes,
  getClientFieldType,
  deleteField,
  updateFieldInForm,
  reOrderFields,
  addField,
  editField,
  updateIntakeForm,
  getClientStatuses,
  updateClientStatus,
  addCustomStatus,
  removeCustomStatus
};
